<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>精选案例</el-breadcrumb-item>
    </el-breadcrumb>    
    <el-card>
      <!-- 添加案例 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            size="small"
            clearable
            placeholder="请输入搜索内容"
            v-model="queryInfo.query"
            @clear="getList">
            <el-button
              slot="append"
              @click="getList"
              icon="el-icon-search">
            </el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button 
            type="primary" 
            size="small" 
            @click="showAddDialog">
            添加
          </el-button>
        </el-col>
      </el-row> 
      <!-- 表格 -->
      <el-row>
        <el-table :data="tableData" border stripe>
          <el-table-column 
            type="index" 
            align="center" 
            size="mini" 
            width="50">
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="title2" label="副标题">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.title2 }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="backimg" label="背景图">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;align-items: center;">
                <img :src="scope.row.backimg" style="width:50px;height: 50px;">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="160px" prop="arLink" label="VR链接">
            <template slot-scope="scope">
              <div style="color:blue;"  @click="showLink(scope.row.arLink)">
                <span>{{ scope.row.arLink }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="220px"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="showEditDialog(scope.row)"
                size="mini">
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="removeUser(scope.row.id)"
                size="mini">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>  
      <!-- 页码 -->
      <el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[2, 5, 10, 15]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>      
      </el-row>   
    </el-card>

    <!-- 添加/编辑 案例 -->
    <el-dialog
      :title="`${userTitle}案例`"
      :visible.sync="userDialog"
      width="38%"
      @close="userDialogClosed">
      <el-form
       :model="userForm"
       :rules="userFormRules"
       ref="userFormRef"
       label-width="90px">
        <el-form-item label="主标题" prop="title">
          <el-input size="small" v-model="userForm.title"></el-input>
        </el-form-item>
        <el-form-item label="副标题" >
          <el-input size="small" v-model="userForm.title2"></el-input>
        </el-form-item>
        <el-form-item label="背景图案">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="uploadImage">
            <img v-if="userForm.imageUrl" :src="userForm.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="AR连接" prop="arLink">
          <el-input size="small" v-model="userForm.arLink"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="userDialog = false" size="small">取消</el-button>
        <el-button v-if="userTitle=='添加'" type="primary" @click="addUserBtn" size="small">确定</el-button>
        <el-button v-else type="primary" @click="editUser" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import table from '@/mixins/tables'
import OSS from 'ali-oss';
export default {
  data () {
    var checkMobile = (rule, val , cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        if (regMobile.test(val)) {
          return cb()
        } else {
          cb(new Error('请输入合法手机号'))
        }
    }
    return {
      userTitle:'添加',
      userDialog: false,
      userForm: {
        userid:0,
        title: '',
        title2: '',
        imageUrl:'',
        mobile: '',
        arLink: '',
        plote:'',
        remork:'',
      },
      userFormRules: {
        title: [
          { required: true, message: '请输入案例标题', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        arLink:[
          { required: true, message: '请输入VR链接', trigger: 'blur' },
        ],
        plote:[
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ]
      },  
      sexOptions: [{
          value: 0,
          label: '男'
        }, {
          value: 1,
          label: '女'
        }],
      typeOptions: [{
          value: 0,
          label: '区域管理员'
        }, {
          value: 1,
          label: '系统管理员'
        }],
      tableData: [ ],
      userCloumn: [
        { name: 'title', label: '标题', minWidth: '160px' } ,
        { name: 'title2', label: '副标题', minWidth: '160px' } ,
        { name: 'arLink', label: 'VR链接', minWidth: '160px' } ,
        { name: 'backimg', label: '背景', minWidth: '160px' }          
      ],  
    }
  },
  mixins: [table],
  created () {
    this.getList()
  },
  methods: {
    getList() {
      var that = this;
      this.$post('/apis/manage/product/tuijianList',{
              page:that.queryInfo.pagenum-1,
              length:that.queryInfo.pagesize,
              token:sessionStorage.getItem('token'),
              name:that.queryInfo.query
          }).then(function(res){
            if(res.errno == 0){
              var data = res.data;
              var newList = [];
              for(var i=0;i<data.list.length;i++){
                newList.push({
                  id:data.list[i].id,
                  title:data.list[i].title,
                  title2:data.list[i].title2,
                  arLink:data.list[i].arLink,
                  backimg:data.list[i].backimg
                })
              }
              that.tableData = newList;
              that.total = data.totalCount;
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
      
    },
    showLink(url){
      console.log(url)
      window.open(url)
    },
    showAddDialog() {
      this.userDialog = true
      this.userTitle = '添加'
    },
    userDialogClosed() {
      this.$refs.userFormRef.resetFields()
      this.userForm.title = ""
      this.userForm.title2 = ""
      this.userForm.arLink = ""
      this.userForm.userid = ""
      this.userForm.imageUrl = ""
    },
    addUserBtn() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/addTuijian',{
              title:this.userForm.title,
              title2:this.userForm.title2,
              arLink:this.userForm.arLink,
              token:sessionStorage.getItem('token'),
              img:this.userForm.imageUrl
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('案例添加成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    showEditDialog(row) {
      console.log('显示编辑案例');
      this.userDialog = true
      this.userTitle = '编辑'
      this.userForm.title = row.title
      this.userForm.title2 = row.title2
      this.userForm.arLink = row.arLink
      this.userForm.userid = row.id
      this.userForm.imageUrl = row.backimg
    },
    editUser() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/editTuijian',{
              userid:this.userForm.userid,
              title:this.userForm.title,
              title2:this.userForm.title2,
              arLink:this.userForm.arLink,
              img:this.userForm.imageUrl,
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('案例信息修改成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    removeUser(id) {
      var that = this;
      const confirmResult = this.$confirm(
        '此操作将永久删除该案例，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'          
        }
      ).then(async () => { //  不要忘记加 async
              window.console.log(1);
              that.$post('/apis/manage/product/delTuijian',{
                userid:id,
                token:sessionStorage.getItem('token'),
              }).then(function(res){
                if(res.errno == 0){
                  that.$message.success('案例删除成功');
                  that.getList();
                }else{
                  that.$message.info(res.errmsg);
                }
              }).catch(function(err){
                
                window.console.log(2);
              });
            
        }).catch(err => err)
    },
    async uploadImage(file) {
      console.log('上传图片');
      console.log(file);
      let that = this
      //const file = event.target.files[0];
      if (!file) return;
 
      
      try {
        // 配置OSS客户端
      const client = new OSS({
        region: 'oss-cn-hangzhou',
        accessKeyId: 'LTAI5t7cyydtfHCta1dgFCuA',
        accessKeySecret: 'x0lQnzUbb7tQscZ0nVpxndoNv1yUu7',
        bucket: 'zxcl',
      });
      // 自定义请求头
      const headers = {
        // 指定Object的存储类型。
        'x-oss-storage-class': 'Standard',
        // 指定Object的访问权限。
        'x-oss-object-acl': 'public-read-write',
        // 通过文件URL访问文件时，指定以附件形式下载文件，下载后的文件名称定义为example.txt。
        'Content-Disposition': 'inline',
        // 设置Object的标签，可同时设置多个标签。
        'x-oss-tagging': 'Tag1=1&Tag2=2',
        // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
        'x-oss-forbid-overwrite': 'false',
      };
      console.log(client);
        // 上传图片
        console.log('上传图片2');
        let now = Date.now()
        let newName = now +'_'+ file.name
        const result = await client.put(newName, file,{headers});
        console.log(result);
        if(result.name != undefined && result.name != ''){
          that.userForm.imageUrl = result.url
        }
      } catch (e) {
        console.error(e);
      }
    },
  }
}
</script>
